import { useState } from "react";
import { Download, PdfIcon } from "../../common/svg/AllSvg";
import { useTranslation } from "react-i18next";

const Documents = () => {
    const [select, setSelect] = useState<any>(0);
    const { t } = useTranslation('common');
    const list: any[] = [
        { id: 1, name: t("recruitment.home.ref_doc.docs.title1"), section: "", link: "Application Form" },
        { id: 2, name: t("recruitment.home.ref_doc.docs.title2"), section: t("recruitment.home.ref_doc.docs.desc2"), link: "Download File" },
        { id: 3, name: t("recruitment.home.ref_doc.docs.title3"), section: "", link: "form-for-obc" },
        { id: 4, name: t("recruitment.home.ref_doc.docs.title4"), section: "", link: "forms-for-sc-st" },
        { id: 5, name: t("recruitment.home.ref_doc.docs.title5"), section: "", link: "MMRCL- Recruitment Norms  Criterions" },
    ]

    const handleDownload = (name: any) => {
        const pdfUrl = `${process.env.PUBLIC_URL}/assets/documents/${name}.pdf`;

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = `${name}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="py-[30px] lg:py-[75px] w-full container flex-col gap-[30px] lg:gap-[40px] flex items-center justify-center">
            <h1 className="text-[#3984AE] font-bold">{t("recruitment.home.ref_doc.title")}
            </h1>

            <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 msm:grid-cols-4 xl:grid-cols-5 gap-[15px] xlx:gap-[25px] w-full">
                {Array.isArray(list) && list?.map((item: any, index: number) => (
                    <button onClick={() => handleDownload(item?.link)} key={index} className={`${select === index ? "shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)] bg-white border border-white" : "border border-[#E5E5E5] dark:border-[#454545]"} flex flex-col items-center justify-between h-full w-full min-h-[290px] xlx:min-h-[303px]`} onMouseEnter={() => setSelect(index)} onFocus={() => setSelect(index)}>
                        <div className="pt-[44px] flex items-center flex-col pb-[18px]">
                            {select === index ?
                                <img src={require("../../../assets/images/doc.gif")} alt="document" className="w-[80px] h-[80px]" />
                                :
                                <div className="min-w-[55px]">
                                    <PdfIcon className="stroke-[#9C9C9C]" />
                                </div>
                            }
                            <h5 className={`pt-[20px] font-bold ${select === index ? "text-primary" : "text-[#3B3B3B] dark:text-white text-opacity-[0.5]"} max-w-[140px] text-center`}>{item?.name}</h5>
                            {!!item?.section && <p className={`${select === index ? "text-blackDull" : "text-[#3B3B3B] dark:text-textBlackDark text-opacity-[0.5]"} font-semibold pt-[17px] max-w-[140px] text-center`}>{item?.section}</p>}
                        </div>

                        <div className={`min-h-[40px] xlx:min-h-[45px] w-full flex items-center justify-center gap-[8px] ${select === index ? "bg-primary" : "bg-[rgba(123,123,123,0.20)] bg-opacity-[0.3]"}`}>
                            <div className="min-w-[14px]">
                                <Download className={`${select === index ? "fill-white" : "fill-[#B8B8B8]"}`} />
                            </div>
                            <h6 className={`${select === index ? "text-white" : "text-[#B8B8B8]"} font-extrabold`}>{t("recruitment.home.ref_doc.download")}</h6>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Documents;